import { useEntryNavigation } from "./saving/useEntryNavigation";
import { useEntryParams } from "./saving/useEntryParams";
import { useSaveEntry } from "./saving/useSaveEntry";

export const useV2Save = () => {
  const params = useEntryParams();
  const navigation = useEntryNavigation(params.logbookId, params.entryIdType);

  const { saveEntry, isSaving } = useSaveEntry(params, navigation);

  return { saveEntry, isSaving };
};
